// extracted by mini-css-extract-plugin
module.exports = {"optionItem":"AddressAutocomplete_optionItem__LRZ5R","itemBoldText":"AddressAutocomplete_itemBoldText__RoM_5","listbox":"AddressAutocomplete_listbox__90WcA"};